import {
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import {
  HandballAttributeId,
  HandballMissedThrowAttribute,
} from '@collector/sportsapi-client-legacy'

export const pitchDistanceAttributeMap = new Map<
  PitchDistance,
  HandballAttributeId
>([
  ['6m', HandballMissedThrowAttribute.SixMeter],
  ['9m', HandballMissedThrowAttribute.NineMeter],
])

export const pitchPositionAttributeMap = new Map<
  PitchPosition,
  HandballAttributeId
>([
  ['left', HandballMissedThrowAttribute.LeftSide],
  ['right', HandballMissedThrowAttribute.RightSide],
  ['left-wing', HandballMissedThrowAttribute.LeftWing],
  ['right-wing', HandballMissedThrowAttribute.RightWing],
  ['center', HandballMissedThrowAttribute.Center],
])
